'use strict';

var _ = require('lodash');
var DualListboxDirective = function DualListboxDirective($timeout) {
  var displayMember = 'name';
  var valueMember = 'name';
  function getListboxSettings(source) {
    return {
      width: 400,
      height: 300,
      multiple: true,
      displayMember: displayMember,
      valueMember: valueMember,
      source: source
    };
  }
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/dual-listbox.html'),
    require: 'ngModel',
    scope: {
      items: '=',
      leftHeader: '@',
      rightHeader: '@'
    },
    link: function link($scope, elem, attr, ngModelCtrl) {
      var listboxes = elem.find('.jqx-listbox');
      $scope.leftItems = [];
      $scope.rightItems = [];
      $scope.leftListBoxSettings = getListboxSettings($scope.leftItems);
      $scope.rightListBoxSettings = getListboxSettings($scope.rightItems);
      $scope.$watch('items', function () {
        $scope.leftItems.length = 0;
        $scope.rightItems.length = 0;
        $scope.leftItems.push.apply($scope.leftItems, $scope.items);
        if (ngModelCtrl.$viewValue) {
          var toBeMoved = _.map(ngModelCtrl.$viewValue, 'name').join(',');
          moveSome(toBeMoved, $scope.leftItems, $scope.rightItems);
          clearSelection();
        }
      });
      $scope.$watch('rightItems', function () {
        var selectedItems = [];
        selectedItems.push.apply(selectedItems, $scope.rightItems);
        ngModelCtrl.$setViewValue(selectedItems);
      }, true);
      listboxes.eq(0).on('change', function (event, selected) {
        $scope.leftSelectedValue = selected;
        $scope.$apply();
      });
      listboxes.eq(1).on('change', function (event, selected) {
        $scope.rightSelectedValue = selected;
        $scope.$apply();
      });
      $timeout(function () {
        var listboxes = elem.find('.jqx-listbox');
        var leftListbox = listboxes.eq(0);
        var rightListbox = listboxes.eq(1);
        leftListbox.on('dblclick', '.jqx-listitem-state-normal', function (event) {
          $scope.shiftRight(event.target.textContent);
          $scope.$apply();
        });
        rightListbox.on('dblclick', '.jqx-listitem-state-normal', function (event) {
          $scope.shiftLeft(event.target.textContent);
          $scope.$apply();
        });
      }, 0);
      function clearSelection() {
        $scope.leftSelectedValue = '';
        $scope.rightSelectedValue = '';
      }
      function moveSome(selected, collectionA, collectionB) {
        if (selected) {
          selected.split(',').forEach(function (d) {
            var index = _.findIndex(collectionA, [valueMember, d]);
            collectionB.push(collectionA[index]);
            collectionA.splice(index, 1);
          });
        }
      }
      $scope.shiftRight = function (toMove) {
        moveSome(toMove, $scope.leftItems, $scope.rightItems);
      };
      $scope.shiftLeft = function (toMove) {
        moveSome(toMove, $scope.rightItems, $scope.leftItems);
      };
      $scope.shiftSelectedRight = function () {
        moveSome($scope.leftSelectedValue, $scope.leftItems, $scope.rightItems);
        clearSelection();
      };
      $scope.shiftSelectedLeft = function () {
        moveSome($scope.rightSelectedValue, $scope.rightItems, $scope.leftItems);
        clearSelection();
      };
      function moveAll(collectionA, collectionB) {
        collectionB.push.apply(collectionB, collectionA);
        collectionA.length = 0;
        clearSelection();
      }
      $scope.shiftEverythingRight = function () {
        moveAll($scope.leftItems, $scope.rightItems);
      };
      $scope.shiftEverythingLeft = function () {
        moveAll($scope.rightItems, $scope.leftItems);
      };
    }
  };
};
DualListboxDirective.$inject = ['$timeout'];
module.exports = DualListboxDirective;